/**
 * Created by user on 2018/6/10/010.
 */

export * from '@lazy-cjk/zh-table-list/list';
export { slugify } from '@lazy-cjk/zh-slugify';
import m from '@lazy-cjk/zh-table-list/list';

export default m
